import { Action, createReducer, on } from '@ngrx/store';
import { GetAllDealStatsState } from './get-all-deal-stats.types';
import { getAllDealStatsAction, getAllDealStatsFailureAction, getAllDealStatsSuccessAction } from './get-all-deal-stats.actions';

const initialState = {
  loading: false,
  loaded: false,
};

const getAllDealStatsReducer = createReducer<GetAllDealStatsState>(
  initialState,
  on(
    getAllDealStatsAction,
    (state, action) => ({
      ...state,
      loading: true,
      loaded: false,
      data: action.refresh ? undefined : state.data,
    })
  ),
  on(
    getAllDealStatsSuccessAction,
    (state, action) => ({
      ...state,
      loading: false,
      loaded: true,
      data: action.data,
      error: undefined,
    })
  ),
  on(
    getAllDealStatsFailureAction,
    (state, action) => ({
      ...state,
      loading: false,
      loaded: false,
      error: action.error,
    })
  ),
);

export const reducer = (state: GetAllDealStatsState, action: Action) => getAllDealStatsReducer(state, action);
